const NoAlert = () => {
	return (
		<div className="bg-white flex items-center justify-center h-[75px] w-[250px] rounded-2xl border-4 border-gray-700">
			<span className="font-Poppins font-semibold text-lg">NO ALERT</span>
		</div>
	);
};

export default NoAlert;
